import React from 'react';
import {
  GridColDef,
  GridRowModesModel,
  GridRowModes,
  GridActionsCellItem,
  GridRowId,
  GridActionsColDef,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import ChartOfAccountsCell from './ChartOfAccountsCell';
import VoucherNameCell from './VoucherNameCell';

const commonColDef: Partial<GridColDef> = {
  flex: 1,
  headerClassName: 'gridHeader--header',
};

export const getVendorColumns = (
  rowModesModel: GridRowModesModel,
  setRowModesModel: React.Dispatch<React.SetStateAction<GridRowModesModel>>,
): GridColDef[] => {
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel(prevModel => ({
      ...prevModel,
      [id]: { mode: GridRowModes.Edit },
    }));
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel(prevModel => ({
      ...prevModel,
      [id]: { mode: GridRowModes.View },
    }));
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel(prevModel => ({
      ...prevModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
  };

  return [
    {
      field: 'companyName',
      headerName: 'Company Name',
      minWidth: 120,
      editable: false,
      ...commonColDef,
    },
    {
      field: 'vendorName',
      headerName: 'Vendor Name',
      minWidth: 150,
      editable: true,
      ...commonColDef,
    },
    {
      field: 'vendorGST',
      headerName: 'Vendor GST',
      minWidth: 120,
      editable: true,
      ...commonColDef,
    },
    {
      field: 'chartOfAccount',
      headerName: 'Chart of Account',
      minWidth: 120,
      editable: true,
      renderEditCell: params => <ChartOfAccountsCell {...params} />,
      ...commonColDef,
    },
    {
      field: 'voucherName',
      headerName: 'Voucher Name',
      minWidth: 100,
      editable: true,
      renderEditCell: params => <VoucherNameCell {...params} />,
      ...commonColDef,
    },
    {
      field: 'tdsRate',
      headerName: 'TDS Rate',
      type: 'number',
      minWidth: 80,
      editable: true,
      ...commonColDef,
    },
    {
      field: 'tdsThreshold',
      headerName: 'TDS Threshold',
      type: 'number',
      minWidth: 100,
      editable: true,
      ...commonColDef,
    },
    {
      field: 'tdsResidual',
      headerName: 'TDS Residual',
      type: 'number',
      minWidth: 100,
      editable: true,
      ...commonColDef,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      minWidth: 80,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              key="save"
              sx={{ color: 'primary.main' }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              key="cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            key="edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
      ...commonColDef,
    } as GridActionsColDef,
  ];
};
